export default "__VITE_ASSET__BU6cd6K6__"